import { get } from 'lodash-es';
import { generatePath } from 'react-router-dom';

import HomeIcon from '@asset/home.icon.svg?react';
import IntegrationIcon from '@asset/integration.icon.svg?react';
import NextIcon from '@asset/next.icon.svg?react';
import WebhookIcon from '@asset/webhook.icon.svg?react';
import { RouteEnum } from '@enum/route.enum';
import { getFormattedNumber } from '@util/data/number';

import { useDashboardStats } from './dashboard-stats.hook';
import { ButtonNext, Col, StatsRow, TitleStat, TitleWrapper, Value, WrapperStats } from './dashboard-stats.style';

export const DashboardStats = () => {
  const data = useDashboardStats();

  return (
    <StatsRow gutter={[16, 16]}>
      <Col>
        <WrapperStats>
          <HomeIcon />
          <TitleWrapper>
            <TitleStat>Consumers</TitleStat>
            <Value>{getFormattedNumber(get(data, ['consumers'], 0))}</Value>
          </TitleWrapper>
        </WrapperStats>
        <ButtonNext href={generatePath(RouteEnum.Consumers.path)} icon={<NextIcon />}>
          View consumers
        </ButtonNext>
      </Col>
      <Col>
        <WrapperStats>
          <IntegrationIcon />
          <TitleWrapper>
            <TitleStat>Integrations</TitleStat>
            <Value>{getFormattedNumber(get(data, ['data', 'integrations'], 0))}</Value>
          </TitleWrapper>
        </WrapperStats>
        <ButtonNext href={generatePath(RouteEnum.Integrations.path)} icon={<NextIcon />}>
          View integrations
        </ButtonNext>
      </Col>
      {/*<Col>*/}
      {/*  <WrapperStats>*/}
      {/*    <SocketIcon />*/}
      {/*    <TitleWrapper>*/}
      {/*      <TitleStat>Connections</TitleStat>*/}
      {/*      <Value>{getFormattedNumber(get(data, ['connections'], 0))}</Value>*/}
      {/*    </TitleWrapper>*/}
      {/*  </WrapperStats>*/}
      {/*  <ButtonNext href={generatePath(RouteEnum.Consumers.path)} icon={<NextIcon />}>*/}
      {/*    View consumers*/}
      {/*  </ButtonNext>*/}
      {/*</Col>*/}
      <Col>
        <WrapperStats>
          <WebhookIcon />
          <TitleWrapper>
            <TitleStat>Webhooks</TitleStat>
            <Value>{getFormattedNumber(get(data, ['webhooks'], 0))}</Value>
          </TitleWrapper>
        </WrapperStats>
        <ButtonNext href={generatePath(RouteEnum.Webhooks.path)} icon={<NextIcon />}>
          View webhooks
        </ButtonNext>
      </Col>
    </StatsRow>
  );
};
